import { useQuery } from '@tanstack/react-query'
import { questionnaire } from '@/utils/constants/callService'
import {
  QuestionnaireOld,
  QuestionByQuestionnaire,
} from '@/service/questionarie/response'

export const questionnaireQueryKeys = {
  all: ['questionnaires'] as const,
  filters: () => [...questionnaireQueryKeys.all, 'filters'] as const,
  questions: (id: number | string) =>
    [...questionnaireQueryKeys.all, 'questions', id] as const,
}

export const useGetQuestionnaires = () => {
  return useQuery<QuestionnaireOld[], Error>({
    queryKey: questionnaireQueryKeys.filters(),
    queryFn: async () => {
      const response = await questionnaire.getAllQuestionaries()
      if (response?.errors) {
        throw new Error(response.errors[0]?.message || 'Error loading questionnaires')
      }
      return response
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}

export const useGetQuestionsByQuestionnaire = (id: number | null) => {
  return useQuery<QuestionByQuestionnaire[], Error>({
    queryKey: questionnaireQueryKeys.questions(id ?? 'null'),
    queryFn: async () => {
      if (!id) return []
      const response = await questionnaire.getQuestionsByQuestionnaireId(id)
      if (response?.errors) {
        throw new Error(response.errors[0]?.message || 'Error loading questions')
      }
      return response
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
